var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#D3ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 23.3335H22.6667M14.6666 20.6668C13.8348 20.6668 13.0371 20.3507 12.4489 19.7881C11.8607 19.2255 11.5303 18.4625 11.5303 17.6668C11.5303 16.8712 11.8607 16.1081 12.4489 15.5455C13.0371 14.9829 13.8348 14.6668 14.6666 14.6668C14.8631 13.7916 15.4378 13.0225 16.2644 12.5286C17.0909 12.0348 18.1016 11.8567 19.074 12.0335C20.0465 12.2103 20.9011 12.7275 21.4498 13.4714C21.9985 14.2153 22.1964 15.1249 22 16.0001H22.6666C23.2855 16.0001 23.879 16.246 24.3166 16.6836C24.7541 17.1211 25 17.7146 25 18.3335C25 18.9523 24.7541 19.5458 24.3166 19.9834C23.879 20.421 23.2855 20.6668 22.6666 20.6668H14.6666Z",
    stroke: "#0368B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFogIcon);
export default __webpack_public_path__ + "static/media/FogIcon.9e7e23d8c65634d21d547a84290836c7.svg";
export { ForwardRef as ReactComponent };